// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__Lo7dg","filters_close":"FiltersBlock_filters_close__FK3vQ"};